import { render, staticRenderFns } from "./forGoods.vue?vue&type=template&id=35aa5ae4&scoped=true&"
import script from "./forGoods.vue?vue&type=script&lang=js&"
export * from "./forGoods.vue?vue&type=script&lang=js&"
import style0 from "./forGoods.vue?vue&type=style&index=0&id=35aa5ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aa5ae4",
  null
  
)

export default component.exports